import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { Widget } from 'src/dashboard/Componets/Widget';
import { Suspense } from 'react';
import { DoughnutChartCardSkeleton } from 'src/common/components/Graphs/common/Graphs/components/DoughnutChartCardSkeleton';
import { AreaChartSkeleton } from 'src/common/components/Graphs/common/Graphs/components/AreaChartSkeleton';
import {
  GridLayout,
  GridLayoutItem,
  GridLayoutWideItem,
} from 'src/common/components/Layouts/GridLayout/GridLayout';
import { useSelectedProduct } from '../hooks/useSelectedProduct';
import { ProductSummaryUsageChartWidget } from './ProductSummaryUsageChartWidget';
import { SubscriptionStatusChart } from './SubscriptionStatusChart';
import { DoughnutWidgetErrorBoundary } from 'src/dashboard/Componets/DoughnutWidgetErrorBoundary';

const AreaChartSkeletonContainer = styled(Box)(({ theme }) => ({
  height: `calc(100% - ${theme.spacing(20)})`,
}));

export const ProductsSummaryGraphs = () => {
  const { t } = useTranslation();
  const { selectedProductId } = useSelectedProduct();

  return (
    <GridLayout>
      <GridLayoutItem key="subscriptionStatus" data-testid="subscriptionsStatus">
        <DoughnutWidgetErrorBoundary title={t('dashboard.subscriptionsStatusChart.title')}>
          <Widget title={t('dashboard.subscriptionsStatusChart.title')}>
            <Suspense fallback={<DoughnutChartCardSkeleton />}>
              <SubscriptionStatusChart tariffCode={selectedProductId} />
            </Suspense>
          </Widget>
        </DoughnutWidgetErrorBoundary>
      </GridLayoutItem>

      <GridLayoutWideItem key="cumulativeUsage" data-testid="cumulativeUsage">
        <DoughnutWidgetErrorBoundary title={t('dashboard.cumulativeUsageChart.title')}>
          <Suspense
            fallback={
              <Widget title={t('dashboard.cumulativeUsageChart.title')}>
                <AreaChartSkeletonContainer>
                  <AreaChartSkeleton />
                </AreaChartSkeletonContainer>
              </Widget>
            }
          >
            <ProductSummaryUsageChartWidget productCode={selectedProductId} />
          </Suspense>
        </DoughnutWidgetErrorBoundary>
      </GridLayoutWideItem>
    </GridLayout>
  );
};
